import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Nashville needed",
      "Ideal for MTSU study-abroad students with deadlines",
      "Perfect for Nissan Smyrna business travelers",
      "Great for Rutherford County families with planned trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Murfreesboro post offices",
      "Good for planned international trips from BNA",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Rutherford County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Nashville (~35 mi) — no Murfreesboro walk-in",
      "NPIC appointment required before traveling to Nashville",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function MurfreesboroProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Murfreesboro"
      introText="Murfreesboro travelers — MTSU students with study-abroad deadlines, Nissan Smyrna engineers with business travel to Japan, Nashville metro commuters with international conferences, and Rutherford County families planning summer vacations — have several options for getting a passport fast. Here is how they compare, and why most Murfreesboro-area residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to Nashville."
      options={options}
      emergencyDescription="Murfreesboro does not have its own regional passport agency. The closest is the Atlanta Passport Agency at 805 Broadway — about 35 miles north via I-24. For MTSU students with approaching study-abroad deadlines and Rutherford County professionals with compressed business travel schedules, the I-24 Nashville commute, downtown parking fees, and uncertainty of walk-in appointment availability make the DIY agency route a gamble that most Murfreesboro travelers prefer to avoid."
      disclaimerText="*Processing speed depends on eligibility and documentation. Murfreesboro does not have a regional passport agency — the closest is Nashville, approximately 35 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}